type WorkHistoryCreatedHandler = (_historyId: string, _featureFlag?: string) => void;

const _handlers: Array<{ handler: WorkHistoryCreatedHandler; featureFlag?: string }> = [];

export const registerCreatedHandler = (handler: WorkHistoryCreatedHandler, featureFlag?: string): void => {
  _handlers.push({ handler, featureFlag });
};

export const notifyCreated = (historyId: string, isEnabled: (_key: string) => boolean): void => {
  _handlers.forEach(({ handler, featureFlag }) => {
    if (!featureFlag || isEnabled(featureFlag)) {
      handler(historyId, featureFlag);
    }
  });
};
